export default {
    summary_text: 'Your EcoCredits Summary',
    membership: 'MEMBER',
    current_tier: 'Current Tier',
    points: 'EcoCredits',
    points_balance: 'EcoCredits Balance',
    points_progress_tips: 'EcoCredits Needed to Reach {plus}: {points} EcoCredits',
    coming_soon: 'Coming Soon',
    redeem_now: 'REDEEM NOW',
    points_activity: 'POINTS ACTIVITY',
    how_it_works: 'How It Works',
    already_member: 'Already a member?',
    already_member1: 'Already a member?',
    sign_up: 'Sign Up',
    sign_up_desc: 'Create an account and get 500 EcoCredits reward.',
    sign_up_desc_h: '500 EcoCredits when you join.',
    earn_points: 'EARN EcoCredits',
    earn_points_desc: 'Earn EcoCredits every time you shop.',
    redeem_points: 'REDEEM EcoCredits',
    redeem_points_desc: 'Redeem EcoCredits for exclusive discounts.',
    earn_points_title: 'Ways to Earn EcoCredits',
    sign_up_text: '500 EcoCredits upon joining',
    completed_text: 'You have already achieved this reward.',
    subscribe: 'Subscribe',
    subscribe_capital_letters: 'Subscribe',
    subscribe_text: 'Sign up for the EcoFlow newsletter.',
    subscribe_hover: 'Earn 500 EcoCredits when you join.',
    subscribe_now: 'Subscribe Now',
    email_address: 'Email Address',
    shop: 'Shop',
    shop_capital_letters: 'Shop',
    earn_point_by_order: 'Earn every time you order.',
    earn_point_rule_shop: 'Get 1 EcoCredits for every $1 you spend.',
    shop_to_earn_points: 'Shop To Earn EcoCredits',
    warranty: 'Warranty',
    warranty_capital_letters: 'Warranty',
    warranty_desc1: '1000 EcoCredits when you register a product.',
    warranty_desc2: '1000 EcoCredits when you register a product.',
    profile: 'Profile',
    profile_desc1: 'Earn up to 1000 EcoCredits for completing your profile.',
    profile_desc2: 'Get up to 1000 EcoCredits for adding your details.',
    complete_profile: 'Complete Profile',
    referral: 'Invited A Friend',
    referral_desc: 'Earn EcoCredits for each friend who successfully signs up.',
    referral_btn: 'Join Now',
    redeem_ecocredits_title: 'Redeem EcoCredits Rewards',
    have_points: 'You have <code>{points} EcoCredits</code>',
    view_all: 'View all',
    coupon: 'Discount code',
    discount: 'Discount',
    gift_card: 'Gift Card',
    redeemed_succ: 'Redeemed successfully!',
    copy_desc: 'You have copied the code, please go to the store to use it.',
    store: 'Shop Now',
    coupon_used_desc: 'Use this code at checkout to redeem your {amont} gift card.',
    rules: 'Rules',
    off: 'OFF',
    site_rules: 'For AU store only.',
    days_rules: 'Valid for {days} days from redemption.',
    product_rules: 'For {product} only.',
    days_rules2: 'Valid from {data}.',
    rewards_redeemed: 'My Rewards',
    redeedmed_tab_name: 'Redeemed',
    issued_tab_name: 'Issued',
    available: 'Available',
    redeemed: 'Redeemed',
    expired: 'Expired',
    edeemed_rewards_note: 'Your redeemed rewards will appear here.',
    browse_ecocredits_rewards: 'Browse EcoCredits Rewards',
    used: 'Used',
    give_away: 'Give away',
    or_text: 'OR',
    send_your_friend: 'Send your {amont} gift card to a friend.',
    points_activity_a: 'My Activity',
    points_tab_name: 'EcoCredits Activity',
    rewards_tab_name: 'Rewards Activity',
    date: 'Date',
    action: 'Action',
    rewards_title: 'Rewards',
    type_title: 'Type',
    discount_type: 'Discount',
    purchase: 'Purchase',
    profile_a: 'Profile',
    refund: 'Refund',
    registered: 'Registered',
    points_capital_letters: 'EcoCredits',
    status: 'Status',
    pending: 'Pending',
    received: 'Received',
    deducted: 'Deducted',
    view_more: 'View More',
    history_note: 'Your EcoCredits activity will appear here. Don’t see your EcoCredits yet? Your activity will update within 24 hours.',
    lucky_flop_start: 'Join Now',
    lucky_flop_congrat: 'Congratulations',
    lucky_flop_get: 'Claim',
    lucky_flop_open: 'OPEN',
    ecoflow_benefits: 'EcoCredits Benefits',
    membership_includes: 'MEMBERSHIP INCLUDES',
    see_t_c: 'See Terms and Conditions',
    manually_added: 'Manually Added',
    manually_deducted: 'Manually Deducted',
    faq_title: 'Frequently Asked Questions',
    redeeming_points: 'REDEEMING EcoCredits',
    network_error: 'Network Error',
    confirm_text: 'Are you sure you want to redeem? Cannot be undone.',
    confirm_btn: 'Confirm',
    no_enough_points: 'Redemption failed, your EcoCredits are not enough',
    no_history_note: 'Don’t see your EcoCredits yet? Your activity will update with in 24 hours.',
    no_coupon_note: 'No rewards redeemed yet.',
    minimum_price: 'Minimum purchase amount ({price}).',
    minimum_num: 'Minimum quantity of items({num} pcs).',
    stay_too_long: 'Your session has expired. Please refresh the page and try again.',
    order_rule: 'Only one discount code per order.',
    purchas_rule: 'Purchasing an item for less than the coupon(s), will forfeit the difference.',
    profile_birthday: 'Profile - birthday',
    profile_address: 'Profile - address',
    profile_username: 'Profile - username',
    profile_picture: 'Profile - picture',
    profile_contact: 'Profile - contact info',
    learn_more: 'Learn more',
    profile_detail:
        'Complete your profile for up to 1000 EcoCredits, including profile pic (200), user name (100), contact info (300), address (200), and birthday (200).',
    exceeded_counts: 'Failed to redeem. You have exceeded the redemption limit.',
    grab_title: 'Grab an EcoCredits Bonus',
    grab_sub_title: 'Exclusive limited-time offers for EcoCredit members. Click to claim now!',
    grab_btn_text: 'Grab My Bonus',
    grab_success_title: 'Congratulations',
    grab_success_text1: 'Bonus claimed successfully!\n Paste the code at checkout to get your discount.',
    grab_success_text2: 'Check your bonuses in <code>My Rewards</code>.',
    'no-grab-content-note': 'More offers coming soon!',
    copy_desc_2: 'You have copied the code.',
    city_validatino_error: 'Invalid city',
    product_text: 'Product',
    shipping_address_text: 'Shipping address',
    saved_address_text: 'Saved addresses',
    use_new_address: 'use a new address',
    spend_now: 'Spend Now',
    stock_left: '{stock} Left',
    no_stock_tip: 'Coming soon... Stay tuned!',
    order_text: 'Order',
    campaign_time_limit_text: 'Valid redemption period: {startTime} - {endTime}.',
    event_action_text: 'Event',
    warranty_minus_action_text: 'Warranty Deleted',
    question_correctly: 'Answer the question correctly',
    referral_correctly: 'Referral program',
    confirm_btn_text: 'Close',
    lucky_turntable_title: 'Lucky Spin',
    join_lucky_with_points: 'It costs you {points} EcoCredits to do one round of Lucky Spin.',
    join_lucky_with_points2: 'It costs you {points} EcoCredits to play a round.',
    join_lucky_desc: 'Spin the wheel and get a great prize!',
    remaining_number: '<code></code> spins left',
    remaining_number2: '<code></code> flips left',
    learn_lucky_rule: 'Learn more about the rules',
    prize_coupon_title: 'Congratulations',
    prize_coupon_sub_title: 'The prize was claimed successfully! Use the code at checkout to save.',
    prize_coupon_action: 'Check your prizes in <code>My Rewards</code>.',
    prize_coupon_button: 'Shop Now',
    prize_points_title: 'Congratulations',
    prize_points_desc: 'Check the just-added EcoCredits in <code>My Activity</code>.',
    limit_times_in_day: 'You can spin the wheels <count></count> times in <day></day> days',
    limit_times_in_day2: 'You can flip the cards <count></count> times in <day></day> days',
    limit_times_in_active: 'During the event, you can spin the wheels up to <count></count> times.',
    limit_times_in_active2: 'During the event, you can flip the cards up to <count></count> times.',
    without_limit_times: 'You can spin the wheels <count></count> times at any time.',
    without_limit_times2: 'You can flip the cards <count></count> times at any time.',
    active_is_unstart: 'This event is coming soon.',
    active_is_ended: 'This event has ended.',
    over_max_count: 'You have exceeded the number of spins available.',
    notice_title: 'Notice',
    points_cash: 'Points Redemption',
    Pending1: 'Pending',
    rollback: 'Returned',
    level_change_log: 'Tier Activity',
    deadline: 'Valid Until',
    history_refresh_member: 'Current Tier: Member',
    history_refresh_plus_member: 'Current Tier: PLUS Member',
    register: 'Register as a Member',
    upgrade: 'Upgrade to PLUS Member',
    demotion: 'Downgrade to Member',
    relegation: 'Maintain as PLUS Member',
    ecocredits_notice1:
        'We have updated the EcoCredits rules on 17 Oct 2024. Please carefully read our updated [<line1>EcoCredits rules</line1>] before using your EcoCredits.',
    wattayear_2024: 'Share#WattAYear',
    clock_in: 'Check-in',
    copy_success1: 'You have copied the code, please go to the store to use it.',
};
